import { useMemo, useContext } from 'react';

import { WindowContext } from '@providers/WindowProvider';
import isCssTransforms3dSupported from '@utils/featureDetection/cssTransforms3d';

function useCssTransforms3dSupported() {
  const windowObject = useContext(WindowContext);

  const isStickySupported = useMemo(
    () => Boolean(windowObject && isCssTransforms3dSupported()),
    [windowObject],
  );

  return isStickySupported;
}

export default useCssTransforms3dSupported;
